import styleConstants from "../scss/_variables.module.scss";

export const devices = {
  tablet: `(min-width: ${styleConstants.tabletScreenWidth})`,
};
